
import { useRef } from "react";
import axiosInstance from "../Api/axiosInstance";
import { API_ENDPOINTS } from "../Api/apiEndPoints";

export const useExcelPolling = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const pollOnce = async (
    fileDownloadId: number,
    {
      onSuccess,
      onFailed,
      onPending,
      onProcessing,
      onExpired,
      onDeleted,
      onStatusUpdate 
    }: any
  ) => {
    try {
      const res = await axiosInstance.get(
        `${API_ENDPOINTS.GLOBAL_EXCEL.EXCEL_DOWNLOAD}?fileDownloadId=${fileDownloadId}`
      );

      const data = res.data.data;
      const { status } = data;
      console.log("Polling Status:", status);
      if(onStatusUpdate){
        onStatusUpdate(status);
      }

      if (status === "pending") {
        onPending && onPending();
        return false;
      }

      if (status === "processing") {
        onProcessing && onProcessing(res.data.message);
        return false;
      }

      if (status === "completed") {
        onSuccess(data.fileDownloadUrl);
        return true; // stop polling
      }

      if (status === "failed") {
        onFailed(res.data.message || "File generation failed");
        return true;
      }

      if (status === "expired") {
        onExpired && onExpired(res.data.message);
        return true;
      }

      if (status === "deleted") {
        onDeleted && onDeleted(res.data.message);
        return true;
      }

      return false;
    } catch (err) {
      onFailed("Something went wrong!");
      return true; // stop polling
    }
  };

  const startPolling = (
    fileDownloadId: number,
    interval: number,
    callbacks: any
  ) => {

    // 🟢 1️⃣ FIRST CALL immediately
    pollOnce(fileDownloadId, callbacks).then((shouldStop) => {
      if (shouldStop) return;

      // ⏳ 2️⃣ NEXT CALLS happen after interval
      intervalRef.current = setInterval(async () => {
        const stop = await pollOnce(fileDownloadId, callbacks);
        if (stop) clearInterval(intervalRef.current!);
      }, interval);
    });
  };

  const stopPolling = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  return { startPolling, stopPolling };
};
